module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/admin/admin-layout.component.html
// module id = ./src/app/layout/admin/admin-layout.component.html
// module chunks = main